<div class="app-background w-screen h-screen flex justify-content-center align-items-center">
  <!--
  <div class="flex justify-content-end w-full absolute top-0 right-0 p-3">
    <button
      class="p-link p-button-link text-primary cursor-pointer p-0 border-0 bg-transparent"
      style="text-decoration: underline"
      (click)="signOut()"
      type="button"
    >
      {{ 'SIGN_OUT' | translate }}
    </button>
  </div>
-->

  <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6 max-w-30rem">

    <div class="text-center">
      <span class="email-icon-wrapper mb-3">
        <i class="pi pi-building big-email-icon"></i>
      </span>
      <div *ngIf="state === 'idle'">
        <div class="text-900 font-medium mb-2 text-2xl">
          {{ 'NOT_PART_OF_ORG' | translate }}
        </div>
        <div class="mb-4 text-600">{{ 'CREATE_ORG_OR_WAIT' | translate }}</div>
        <button pButton pRipple [label]="'CREATE_ONE' | translate" class="p-button flex-1"
          (click)="openDialog()"></button>
      </div>
      <div *ngIf="state === 'success'">
        <div class="text-900 font-medium mb-2 text-2xl">
          {{ 'ORG_CREATED' | translate }}
        </div>
        <div class="mb-4 text-600">
          {{ 'ORG_CREATED_SUCCESS' | translate }}
        </div>
        <button pButton pRipple [label]="'GO_TO_DASHBOARD' | translate" class="p-button flex-1"
          (click)="goToDashboard()"></button>
      </div>

      <p-dialog *ngIf="showDialog" [(visible)]="showDialog" [modal]="true" [closable]="true" [dismissableMask]="true"
        [style]="{ maxWidth: '600px'}" (onHide)="closeDialog()">
        <ng-template pTemplate="header">
          <div class="w-full flex flex-row align-items-center justify-content-center text-center">
            <i class="pi pi-building mr-2 text-2xl font-bold" style="vertical-align: middle;"></i>
            <span class="align-middle font-bold text-xl" style="text-transform: uppercase;">{{ 'CREATE_ORG' | translate }}</span>
          </div>
        </ng-template>
        <div class="pb-5"></div>
        <app-crud-org [mode]="'create'" [styleForOnboarding]="true" (cancelPressed)="closeDialog()"></app-crud-org>
      </p-dialog>

    </div>
  </div>
</div>